import type { EdgeDescriptor } from '@bliks-io/ui';
import { markTerminal } from './successorInvariant';
import type { EdgeActionDeps } from './types';

/**
 * Flip the source step's successor (or the clicked rule branch, for decision
 * steps) into the UNCLEAR terminal state. The cascading helper sweeps any
 * real downstream steps and draft-assignment placeholders so the UNCLEAR
 * marker is the sole successor — preserving the "terminal XOR connected"
 * invariant — in one request, so one undo entry.
 */
export async function performMarkUnclear(
  edge: EdgeDescriptor,
  deps: EdgeActionDeps
): Promise<void> {
  const { source } = edge;
  if (!source.stepId) return;
  const ruleIds = edge.ruleId ? [edge.ruleId] : undefined;
  await markTerminal(source.stepId, ruleIds, { status: 'UNCLEAR' }, deps);
}
